"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logPrefix = `[mobx-easy] -`;
exports.logPrefix = logPrefix;
const getFirstWrapper = (wrapperItems) => {
    if (wrapperItems.size === 0) {
        throw new Error(`${logPrefix} no wrapped items!`);
    }
    const values = wrapperItems.values();
    return values.next();
};
exports.getFirstWrapper = getFirstWrapper;
const getWrapper = (wrapperItems, wrapperId) => {
    const wrapper = wrapperItems.get(wrapperId);
    if (!wrapper) {
        throw new Error(`${logPrefix} no wrapper items id: ${wrapperId}, wrapperItems size: ${wrapperItems.size}`);
    }
    return wrapper;
};
exports.getWrapper = getWrapper;
const generateId = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
};
exports.generateId = generateId;
//# sourceMappingURL=utils.js.map